import React from "react";

import { HookFormInput } from "components";
import { required, trimNormalizer, maxLength2000 } from "validators";

import styles from "../pend.module.scss";

type DetailsFieldProps = { loading: boolean; register: any; errors: any };

const DetailsField = ({
	loading = false,
	register,
	errors,
}: DetailsFieldProps) => {
	return (
		<HookFormInput
			name="details"
			register={register}
			validator={{ required, maxLength2000 }}
			normalizeOnBlur={trimNormalizer}
			colLabel={12}
			colInput={12}
			label="Pend Details"
			placeholder="Details"
			blurLoading={loading}
			errors={errors}
			showRequiredMark
			as="textarea"
			inputBlockClassName={styles.textareaWrraper}
			labelClassName="pt-0"
		/>
	);
};

export default DetailsField;
